function ListGroupType3({ label = "Fill Label", value = "Fill Value" }) {
  return (
    <>
      <div className="list-group list-group-flush">
        <div className="list-group-item d-flex align-items-center">
          <div className="flex-1 text-break">
            <div className="text-theme">{label}</div>
            <div className="text-inverse text-opacity-50">{value}</div>
          </div>
        </div>
      </div>
    </>
  );
}
export default ListGroupType3;
